// @flow
import React, { Component } from 'react';
import { Button, Dropdown } from 'semantic-grab-ui/src';
import {
  operatorOptions,
  getOperatorDisp,
} from 'omega-rtc/components/rule-builder/utils';
import SegpModal from './SegpModal';
import './SegpRule.scss';

type Rule = {
  lhs?: string;
  rhs?: any;
  operator?: string;
};

type RuleType = {
  noun?: string;
  [key: string]: any;
};

type SegpRuleProps = {
  rule: Rule;
  isSelected: boolean;
  ruleType: RuleType;
  onRuleChange: (rule: Rule) => void;
  onRuleRemove: () => void;
};

type SegpRuleState = {
  showModal: boolean;
};

type AppMode = 'mex' | 'pax' | 'dax' | '';

export default class SegpRule extends Component<SegpRuleProps, SegpRuleState> {
  constructor(props: SegpRuleProps) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  handleRuleOperatorSelect = (event: any, dropdown: any): void => {
    const { rule } = this.props;
    const newRule = Object.assign({}, rule, { operator: dropdown.value });
    this.props.onRuleChange(newRule);
  }

  handleShowModal = (): void => {
    this.setState({ showModal: true });
  }

  handleCloseModal = (): void => {
    this.setState({ showModal: false });
  }

  handleChange = (segments: string[]): void => {
    if (segments.length === 0) {
      this.props.onRuleRemove();
    }
    const { rule } = this.props;
    rule.rhs = segments;
    this.props.onRuleChange(rule);
  }

  getSegment = (lhs: string): AppMode => {
    if (!lhs) return '';
    if (lhs.includes('merchant') || lhs.includes('digibank')) {
      return 'mex';
    } else if (lhs.includes('user') || lhs.includes('passenger') || lhs.includes('familyHost')) {
      return 'pax';
    }
    return 'dax';
  }

  getNamespace = (lhs: string): string | undefined => {
    return lhs.includes('digibank') ? 'gxs' : undefined;
  }

  render() {
    const { rule, isSelected, ruleType } = this.props;
    const rhs = rule.rhs || [];
    const lhs = rule.lhs || '';
    return (
      <span>
        <span>{ruleType.noun}</span>
        <span className="horizontal-margin">
          <Dropdown
            inline
            trigger={<span className="rule-field">{getOperatorDisp(rule.operator)}</span>}
            options={operatorOptions(ruleType)}
            defaultValue={rule.operator}
            onChange={this.handleRuleOperatorSelect}
            disabled={!isSelected}
          />
        </span>
        <div className="segp-container">
          <Button className="horizontal-margin" onClick={this.handleShowModal} disabled={!isSelected}>
            {rhs.join(', ')}
          </Button>
          {this.state.showModal && <SegpModal
            onClose={this.handleCloseModal}
            onChange={this.handleChange}
            segments={rule && rule.rhs}
            appMode={this.getSegment(lhs)}
            namespace={this.getNamespace(lhs)}
          />}
        </div>
      </span>
    );
  }
}
